import { Component, inject, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ButtonComponent } from '../button/button.component';
import { ButtonTypeEnum, ButtonSizeEnum } from '../button/buttonTypesEnum';
import { FilterCriteria } from '@model/filter/filter-options.model';

/**
 * Active Filters Display Component
 * Shows currently applied filters as chips/badges with option to clear all
 */
@Component({
  selector: 'app-active-filters',
  standalone: true,
  imports: [CommonModule, TranslateModule, ButtonComponent],
  templateUrl: './active-filters.component.html'
})
export class ActiveFiltersComponent {
  readonly filterCriteria = input<FilterCriteria | null>(null);
  readonly examTypeLabel = input('shared.filterSidebar.sections.examType');
  readonly clearFilters = output<void>();

  readonly ButtonTypeEnum = ButtonTypeEnum;
  readonly ButtonSizeEnum = ButtonSizeEnum;

  private readonly translate = inject(TranslateService);

  private readonly priorityI18nKeys: Record<string, string> = {
    STANDARD: 'resultValidation.filter.priorityStandard',
    ADMINISTRATIVE: 'resultValidation.filter.priorityAdministrative',
    INSTITUTIONAL: 'resultValidation.filter.priorityInstitution',
    CLINICAL: 'resultValidation.filter.priorityClinical',
    '1': 'resultValidation.filter.priorityStandard',
    '2': 'resultValidation.filter.priorityAdministrative',
    '3': 'resultValidation.filter.priorityInstitution',
    '4': 'resultValidation.filter.priorityClinical'
  };

  private readonly statusI18nKeys: Record<string, string> = {
    PENDING_ANALYSIS: 'resultValidation.labelMaps.status.pendingAnalysis',
    IN_ANALYSIS: 'resultValidation.labelMaps.status.inAnalysis',
    PENDING_REASSIGNMENT: 'resultValidation.labelMaps.status.pendingReassignment',
    REPORT_IN_PROGRESS: 'resultValidation.labelMaps.status.reportInProgress',
    PENDING_ASSIGNMENT: 'resultValidation.labelMaps.status.pendingAssignment',
    IN_SIGNATURE: 'resultValidation.labelMaps.status.inSignature',
    SIGNED: 'resultValidation.labelMaps.status.signed',
    IN_CORRECTION: 'resultValidation.labelMaps.status.inCorrection',
    READY_TO_SEND: 'resultValidation.labelMaps.status.readyToSend',
    SENT: 'resultValidation.labelMaps.status.sent',
    COMPLETED: 'resultValidation.labelMaps.status.completed',
    REQUIRES_ADDENDUM: 'resultValidation.labelMaps.status.requiresAddendum',
    PENDING_ADDENDUM: 'resultValidation.labelMaps.status.pendingAddendum',
    SEND_ERROR: 'resultValidation.labelMaps.status.sendError',
    CRITICAL_ERROR: 'resultValidation.labelMaps.status.criticalError'
  };

  getPriorityName(priorityId: string): string {
    const key = this.priorityI18nKeys[priorityId];
    return key ? this.translate.instant(key) : priorityId;
  }

  getStatusName(statusId: string): string {
    const key = this.statusI18nKeys[statusId];
    return key ? this.translate.instant(key) : statusId;
  }

  onClearFilters(): void {
    this.clearFilters.emit();
  }
}
